import React from 'react'
import { config } from 'config'
import { rhythm } from 'utils/typography'
import { prefixLink } from 'gatsby-helpers'
//import THREE from 'lib/three.min'
import ImprovedNoise from 'lib/ImprovedNoise'

class ThreejsBackdrop extends React.Component {

  constructor() {
    super();
    //this.THREE = window.THREE;
    //console.log(this.THREE);

    this.worldWidth = 256;
    this.worldDepth = 256;
    this.worldHalfWidth = this.worldWidth / 2;
    this.worldHalfDepth = this.worldDepth / 2;
    this.camAngle = 0;
    this.camPathRadius = 1000;
    //this.clock = new THREE.Clock();

  }

  init() {
    const THREE = window.THREE;

    this.camera = new THREE.PerspectiveCamera(60, window.innerWidth / window.innerHeight, 1, 20000);
    this.scene = new THREE.Scene();

    this.terrainData = this.generateHeight(this.worldWidth, this.worldDepth);
    this.camera.position.y = this.terrainData[this.worldHalfWidth + this.worldHalfDepth * this.worldWidth ] * 10 + 700;

    var geometry = new THREE.PlaneBufferGeometry( 7500, 7500, this.worldWidth - 1, this.worldDepth - 1 );
    geometry.rotateX( - Math.PI / 2 );

    var vertices = geometry.attributes.position.array;

    for ( var i = 0, j = 0, l = vertices.length; i < l; i ++, j += 3 ) {

      vertices[ j + 1 ] = this.terrainData[ i ] * 10;

    }

    this.texture = new THREE.CanvasTexture( this.generateTexture( this.terrainData, this.worldWidth, this.worldDepth ) );
    this.texture.wrapS = THREE.ClampToEdgeWrapping;
    this.texture.wrapT = THREE.ClampToEdgeWrapping;

    this.mesh = new THREE.Mesh( geometry, new THREE.MeshBasicMaterial( { map: this.texture, wireframe: true } ) );

    this.scene.add( this.mesh );

    // Renderer

    this.renderer = new THREE.WebGLRenderer();
    this.renderer.setClearColor( 0x222222 );
    this.renderer.setPixelRatio( window.devicePixelRatio );
    this.renderer.setSize( window.innerWidth, window.innerHeight );

    this.threeContainer.innerHTML = "";
    this.threeContainer.appendChild( this.renderer.domElement );
    this.threeContainer.style.opacity = 0.5;

    window.addEventListener( 'resize', this.onWindowResize.bind(this), false );

    // Start the loop
    this.camera.position.x = this.camPathRadius * Math.cos(this.camAngle);
    this.camera.position.z = this.camPathRadius * Math.sin(this.camAngle);
    this.camera.lookAt(new THREE.Vector3(0, 0, 0));

    this.renderer.render( this.scene, this.camera );
    this.lastRenderTime = Date.now();
    this.animate();
    
  }

  animate() {
    
    requestAnimationFrame( this.animate.bind(this) );
    const now = Date.now();
    const elapsed = now - this.lastRenderTime;

    this.camera.position.x = this.camPathRadius * Math.cos(this.camAngle);
    this.camera.position.z = this.camPathRadius * Math.sin(this.camAngle);
    this.camera.lookAt(new THREE.Vector3(0, 0, 0));

    this.camAngle += 0.001;

    if (elapsed > 40) {
      this.lastRenderTime = now - (elapsed % 40);
      this.renderThreeJs();
      //stats.update();

    }
  }

  onWindowResize() {

    var width = window.innerWidth;
    var height = window.innerHeight;

    this.camera.aspect = width / height;
    this.camera.updateProjectionMatrix();

    this.renderer.setSize( width, height );

    //this.renderer.setSize( window.innerWidth, window.innerHeight );
    //this.uniforms.resolution.value.x = this.renderer.domElement.width;
    //this.uniforms.resolution.value.y = this.renderer.domElement.height;
  }

  generateHeight(width, height) {
    var size = width * height, data = new Uint8Array( size ),
    perlin = new ImprovedNoise(), quality = 1, z = Math.random() * 100;

    for ( var j = 0; j < 4; j ++ ) {
      for ( var i = 0; i < size; i ++ ) {
        var x = i % width, y = ~~ ( i / width );
        data[ i ] += Math.abs( perlin.noise( x / quality, y / quality, z ) * quality * 1.75 );
      }
      quality *= 5;
    }

    return data;
  }

  generateTexture(data, width, height) {
    const THREE = window.THREE;

    var canvas, canvasScaled, context, image, imageData,
    level, diff, vector3, sun, shade, nx, ny;

    vector3 = new THREE.Vector3( 0, 0, 0 );

    sun = new THREE.Vector3( 1, 1, 1 );
    sun.normalize();

    canvas = document.createElement( 'canvas' );
    canvas.width = width;
    canvas.height = height;

    context = canvas.getContext( '2d' );
    context.fillStyle = '#000';
    context.fillRect( 0, 0, width, height );

    image = context.getImageData( 0, 0, canvas.width, canvas.height );
    imageData = image.data;

    for ( var i = 0, j = 0, l = imageData.length; i < l; i += 4, j ++ ) {

      vector3.x = data[ j - 2 ] - data[ j + 2 ];
      vector3.y = 2;
      vector3.z = data[ j - width * 2 ] - data[ j + width * 2 ];
      vector3.normalize();

      shade = vector3.dot( sun );

      ny = (j / width) / width;
      nx = (j % width) / height;

      imageData[ i ] = ( (255 * nx) + shade * 50 ) * ( 0.5 + data[ j ] * 0.007 );
      imageData[ i + 1 ] = ( (255 * ny) + shade * 50 ) * ( 0.5 + data[ j ] * 0.007 );
      imageData[ i + 2 ] = ( 128 + shade * 50 ) * ( 0.5 + data[ j ] * 0.007 );

      // imageData[ i ] = ( 96 + shade * 128 ) * ( 0.5 + data[ j ] * 0.007 );
      // imageData[ i + 1 ] = ( 32 + shade * 96 ) * ( 0.5 + data[ j ] * 0.007 );
      // imageData[ i + 2 ] = ( shade * 96 ) * ( 0.5 + data[ j ] * 0.007 );
    }

    context.putImageData( image, 0, 0 );

    // Scaled 4x

    canvasScaled = document.createElement( 'canvas' );
    canvasScaled.width = width * 4;
    canvasScaled.height = height * 4;

    context = canvasScaled.getContext( '2d' );
    context.scale( 4, 4 );
    context.drawImage( canvas, 0, 0 );

    image = context.getImageData( 0, 0, canvasScaled.width, canvasScaled.height );
    imageData = image.data;

    for ( var i = 0, l = imageData.length; i < l; i += 4 ) {

      var v = ~~ ( Math.random() * 5 );

      imageData[ i ] += v;
      imageData[ i + 1 ] += v;
      imageData[ i + 2 ] += v;

    }

    context.putImageData( image, 0, 0 );
    return canvasScaled;

  }

  renderThreeJs() {
    //this.uniforms.time.value += 0.05;
    this.renderer.render( this.scene, this.camera );
  }

  componentDidMount(){
    console.log('componentDidMount');
    this.threeContainer.style.height = window.innerHeight + "px";
    //if ( ! Detector.webgl ) Detector.addGetWebGLMessage();
      // var container, stats;
      // var camera, scene, renderer;
      // var uniforms;
    this.init();
  }

  render () {
    return (
      <div ref={(el) => this.threeContainer = el} className="threejs-container"></div>
    )
  }
}

export default ThreejsBackdrop



/** WEBPACK FOOTER **
 ** ../components/ThreejsBackdrop.js
 **/